import React, {useEffect, useState, useRef} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useHistory, useParams} from 'react-router-dom'
import axios from 'axios'
import dayjs from 'dayjs'
import {RootState} from '../../../../../setup'
import {toast} from 'react-toastify'
import {MoonLoader} from 'react-spinners'
import {Typography} from '@mui/material'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import {
  ADD_SPEECH_NOTES_FORM_INPUTS,
  EDIT_SPEECH_NOTES_FORM_INPUTS,
} from '../../../Notes/Speech_therapy/SPEECH_THERAPY_FORM_CONSTANTS'
const selectTimeZone = (state: RootState) => state.timeZone.timeZone
const SpeechTherapyAssessmentForm = () => {
  const [isFormLoading, setIsFormLoading] = useState(false)
  const [formData, setFormData] = useState<any>({})
  const dispatch = useDispatch()
  const [clickCount, setClickCount] = useState(26)
  const params: {id: string} = useParams()
  const [uiElementsList, setUiElementsList] = useState([])
  const timeZone = useSelector(selectTimeZone)
  const history = useHistory()

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setIsFormLoading(true)
    try {
      const res = await axios.get(`/speechTherapy/getById/${params.id}?isDeleted=true`)
      const data = res.data.result

      const response = await axios.get('/clients/getClientNames')
      const {data: clientsList} = response?.data
      const updatedClients = clientsList.map((client) => ({
        label: client.fullName,
        value: client._id,
      }))
      const formattedDate = dayjs.utc(data.date).tz(timeZone, true)
      const formattedDateOfAmendment = dayjs.utc(data.dateOfAmendment).tz(timeZone, true)

      const selectedClient = updatedClients.find((client) => client.value === data?.clientId)

      const baseFormData = {
        clientId: data.clientId,
        date: formattedDate,
        noteType: data.noteType,
        therapist: data.therapist,
        diagnosis: data.diagnosis,
        preTreatmentStatus: data.preTreatmentStatus,
        medicalHistory: data.medicalHistory,
        previousTreatment: data.previousTreatment,
        complicatingIssues: data.complicatingIssues,
        other: data.other,
        prognosis: data.prognosis,
        complicatingFactors: data.complicatingFactors,
        amendments: data.amendments,
        dateOfAmendment: formattedDateOfAmendment,
        longTermGoals: data.longTermGoals,
      }

      const longTermGoals = data.longTermGoals || []
      const goalsFormData = {}
      const goalFields = []

      setFormData({...baseFormData, ...goalsFormData})

      const updatedFormInputs = EDIT_SPEECH_NOTES_FORM_INPUTS().map((item) => {
        if (item.name === 'clientId') {
          return {
            ...item,
            options: updatedClients,
            disabled: true,
            value: selectedClient?.value,
          }
        } else if (item.type === 'SpeechTherapyDialog') {
          return {
            ...item,
            isDisabled: true,
          }
        }
        return {
          ...item,
          disabled: true,
        }
      })

      setUiElementsList([...updatedFormInputs, ...goalFields])
      setClickCount(longTermGoals.length + clickCount)
    } catch (error) {
      toast.error('Failed to fetch data')
    } finally {
      setIsFormLoading(false)
    }
  }
  const buttons = [
    {label: 'Cancel', variant: 'outlined', type: 'button'},
  ]
  return (
    <>
      {isFormLoading ? (
        <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
          <MoonLoader color='#9db2fc' size={60} loading={isFormLoading} />
        </div>
      ) : (
        <FormWrapper
          title='Deleted Speech Therapy Assessment'
          content={
            <>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 'bold',
                  marginBottom: '0.5rem',
                  marginLeft: '1rem',
                }}
                color='primary'
              >
                Note Type
              </Typography>
              <FrequencyDateRangePicker
                isEntry={false}
                isTemplate={false}
                isFullForm={false}
                isEdit={true}
                formData={formData}
                setFormData={setFormData}
              />

              <DynamicForm
                fields={uiElementsList}
                data={formData}
                onSubmit={() => {}}
                buttons={buttons}
              />
            </>
          }
        />
      )}
    </>
  )
}

export default SpeechTherapyAssessmentForm
